module.exports = __webpack_public_path__ + "static/media/28.2a377220.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/28.png
// module id = 395
// module chunks = 0